var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 8,
    viewBox: "0 0 20 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M974.356 167.673c1.792 0 2.856-1.401 2.856-3.774 0-.894-.17-1.646-.498-2.227-.473-.903-1.289-1.391-2.319-1.391-1.533 0-2.617 1.03-2.617 2.475 0 1.358.976 2.344 2.32 2.344.824 0 1.493-.386 1.825-1.055h.083c0 1.612-.61 2.574-1.64 2.574-.606 0-1.074-.332-1.236-.865h-1.254c.21 1.158 1.191 1.92 2.48 1.92zm.044-3.574c-.81 0-1.387-.576-1.387-1.382 0-.786.606-1.387 1.392-1.387.786 0 1.391.61 1.391 1.407 0 .786-.59 1.362-1.396 1.362zm4.824-1.006c.464 0 .782-.327.782-.766 0-.445-.318-.772-.782-.772-.459 0-.78.327-.78.772 0 .439.321.766.78.766zm0 3.662c.464 0 .782-.332.782-.771 0-.445-.318-.772-.782-.772-.459 0-.78.327-.78.772 0 .44.321.771.78.771zm6.656.747v-1.313h.952v-1.065h-.952v-4.668h-1.777c-1.246 1.875-2.237 3.443-2.872 4.61v1.123h3.443v1.313h1.206zm-1.187-2.348h-2.295v-.074c.82-1.445 1.553-2.602 2.227-3.598h.068v3.672zm6.085 2.348v-7.046h-1.255l-1.841 1.29v1.21l1.753-1.23h.083v5.776h1.26z",
    transform: "translate(-971 -160)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.2978e6b0.svg";
export { ForwardRef as ReactComponent };